import { render } from "./CriteriaQuestionDisplay.vue?vue&type=template&id=d72e23b2&scoped=true"
import script from "./CriteriaQuestionDisplay.vue?vue&type=script&lang=js"
export * from "./CriteriaQuestionDisplay.vue?vue&type=script&lang=js"

import "./CriteriaQuestionDisplay.vue?vue&type=style&index=0&id=d72e23b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d72e23b2"],['__file',"src/components/project/CriteriaQuestionDisplay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d72e23b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d72e23b2', __exports__)) {
    api.reload('d72e23b2', __exports__)
  }
  
  module.hot.accept("./CriteriaQuestionDisplay.vue?vue&type=template&id=d72e23b2&scoped=true", () => {
    api.rerender('d72e23b2', render)
  })

}


export default __exports__